import React from 'react';
import ReactDOM from 'react-dom/client';
import './design-system/tokens.css';
import './design-system/global.css';
import './index.css';
import './design-system/workspace-foundation.css';
import App from './App';
import { scrubInitialBrowserUrl } from './components/navigation/urlPrivacy';
import { initializeThemePreference } from './theme/themePreference';

// Remove accidental identity, record, search and token data before the first
// application paint. Protected APIs remain the authority for every request.
scrubInitialBrowserUrl();
initializeThemePreference();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

